import React from 'react'
import { getSortedBlogPosts } from './blogs/blogConfig';
import metadata from './blogs/blogSeoMetadata.json';
import { indexHtml } from './utils/blogPresentation';
import BlogSeo from './components/BlogSeo';

export default function Home() {
    return (
        <>
            <BlogSeo
                title="SafeVault Blog"
                description="Insights on secure document management, digital vaults, document workflows and AI from the SafeVault team."
                canonicalPath="/blog/"
                image="https://safevaultusa.com/images/social/safevault-default-1200x630.png"
                imageAlt="SafeVault social preview"
            />
            <main className="sv-blog-index" dangerouslySetInnerHTML={{__html:indexHtml(getSortedBlogPosts(),metadata)}} />
        </>
    )
}
